import '../../app/config';
import { ppdLagoon, paanLagoon } from '../lagoon';

const FEATURES = {};
const PAAN_FEATURES = {};

export const loadFeatures = async () => {
  await ppdLagoon.init();

  ppdLagoon.lagoon
    .getTable('feature-flags')
    .getRow()
    .forEach(featureFlag => {
      FEATURES[featureFlag.key] = featureFlag.active;
    });
};

export const loadPaanFeatures = async () => {
  await paanLagoon.init();

  paanLagoon.lagoon
    .getTable('feature-flags')
    .getRow()
    .forEach(featureFlag => {
      PAAN_FEATURES[featureFlag.key] = featureFlag.active;
    });
};

export const getFeature = key => {
  return FEATURES[key] || false;
};

export const getPaanFeature = key => {
  return PAAN_FEATURES[key] || false;
};
